module.exports = __webpack_public_path__ + "static/media/Indonesia-logo.9ca23325.png";